var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5045 24.9784C28.3609 24.9784 33.9191 19.5641 33.9191 12.8852C33.9191 6.20631 28.3609 0.791992 21.5045 0.791992C14.6481 0.791992 9.08984 6.20631 9.08984 12.8852C9.08984 19.5641 14.6481 24.9784 21.5045 24.9784Z",
    stroke: "#06F3A3",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.869576 51.4298C0.828925 50.9387 0.812659 50.4477 0.812659 49.9567C0.758116 47.2768 1.25288 44.6132 2.268 42.1218C3.28312 39.6304 4.7982 37.3612 6.72457 35.4472C8.65094 33.5331 10.9499 32.0126 13.4869 30.9745C16.0239 29.9365 18.748 29.4019 21.4997 29.4019C24.2514 29.4019 26.9754 29.9365 29.5124 30.9745C32.0494 32.0126 34.3484 33.5331 36.2747 35.4472C38.2011 37.3612 39.7162 39.6304 40.7313 42.1218C41.7464 44.6132 42.2412 47.2768 42.1866 49.9567C42.1866 50.4715 42.1866 50.9862 42.1297 51.4931",
    stroke: "#7929FB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9918 32.1219C19.9918 32.1219 22.065 31.6625 23 32.1219L22.374 33.0801L23.6179 48.9193L21.8049 51.9684L19.9756 48.9668L20.691 33.1277L19.9918 32.1219Z",
    fill: "#7829FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.a6558ee639e6f6cd30af50d2756d5f90.svg";
export { ForwardRef as ReactComponent };